// Estado vazio/feedback padrão (rule 03 §5): ícone em círculo, título,
// descrição e ação opcional. Só renderiza — o texto vem por props (i18n de
// quem usa). Atributos de `div` (`role`, `data-testid`) passam direto.
import type { LucideIcon } from "lucide-react"
import type {
  ComponentPropsWithoutRef,
  ReactNode,
} from "react"

import { cn } from "@/lib/utils"

interface EmptyStateProps extends Omit<
  ComponentPropsWithoutRef<"div">,
  "title"
> {
  icon: LucideIcon
  title: ReactNode
  description?: ReactNode
  /** Botão/link de próxima ação (criar, limpar filtros, tentar de novo). */
  action?: ReactNode
  className?: string
}

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  className,
  ...rest
}: EmptyStateProps) => (
  <div
    {...rest}
    className={cn(
      "flex flex-col items-center gap-3 rounded-xl border border-dashed py-10 text-center",
      className
    )}
  >
    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted">
      <Icon
        className="h-6 w-6 text-muted-foreground/40"
        aria-hidden="true"
      />
    </div>
    <div>
      <p className="text-sm font-medium">{title}</p>
      {description && (
        <p className="text-xs text-muted-foreground">
          {description}
        </p>
      )}
    </div>
    {action}
  </div>
)
